import React, { useCallback } from 'react'

import ProjectListItem from './ProjectListItem'
import { Project } from './types'

interface ProjectSwitchPanelProps {
  className?: string
  isProcessing?: boolean
  projects: Project[]
  handleProjectSelect: (projectId: string) => void
}

function ProjectSwitchPanel({
  className = '',
  isProcessing,
  projects,
  handleProjectSelect,
}: ProjectSwitchPanelProps) {
  const handleClickProject = useCallback(
    (projectId: string) => () => handleProjectSelect(projectId),
    [handleProjectSelect]
  )

  return (
    <div
      className={`rounded-[20px] border border-solid border-white/15 bg-[#081C3499]/60 ${className}`}
    >
      <div className="custom-scrollbar flex h-full max-h-[60vh] w-full flex-col gap-1 overflow-y-auto p-[8px]">
        {projects.map((project) => (
          <ProjectListItem
            key={project.id}
            canonicalName={project.canonicalName}
            label={project.label || project.name}
            onClick={handleClickProject(project.id)}
            isProcessing={isProcessing}
          />
        ))}
      </div>
    </div>
  )
}

export default ProjectSwitchPanel
